export default __webpack_public_path__ + "static/media/percentOrange.27a8391f.svg";